import React, { useState, useEffect, useRef } from "react";
import "../styles/Home.css";

// Desktop images
import hero1Web from "../assets/bg1.png";
import hero2Web from "../assets/bg2.png";

// Mobile images
import hero1Mob from "../assets/bgmob1.png";
import hero2Mob from "../assets/bgmob2.png";

import About from "../components/About";
import trainer from "../assets/guru.jpg";
import { FaWhatsapp } from "react-icons/fa";
import ContactFormWindow from "../components/ContactFormWindow";
import ClassesSection from "../components/ClassesSection";

function Home() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [currentSection, setCurrentSection] = useState("Welcome");

  const sectionRefs = {
    none: useRef(null),
    about: useRef(null),
    classes: useRef(null),
    trainers: useRef(null),
    inquiry: useRef(null),
  };

  const sectionLabels = {
    none: "Welcome",
    about: "About Vedyo",
    classes: "Our Classes",
    trainers: "Meet Our Teacher",
    inquiry: "Contact Us",
  };

  const slidesWeb = [hero1Web, hero2Web];
  const slidesMob = [hero1Mob, hero2Mob];
  const slides = isMobile ? slidesMob : slidesWeb;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [slides]);

  // Floating label scroll logic
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionId = entry.target.id;
            setCurrentSection(sectionLabels[sectionId] || "Welcome");
          }
        });
      },
      { threshold: 0.5 }
    );

    Object.values(sectionRefs).forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="home-section">
      {/* Floating Section Label */}
      <div className="floating-label-fixed">{currentSection}</div>
      <section id="none" ref={sectionRefs.none}>
      {/* Hero Slider */}
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <img
            key={index}
            src={slide}
            alt={`Slide ${index + 1}`}
            className={`hero-slide ${index === activeIndex ? "active" : ""}`}
          />
        ))}
        <div className="scroll-indicator">
          <span>Scroll</span>
          <div className="scroll-line"></div>
        </div>
      </div>
      </section>

      {/* About Section */}
      <section id="about" ref={sectionRefs.about} className="about-section">
        <About />
      </section>

      {/* Classes Section */}
      <section id="classes" ref={sectionRefs.classes} className="section-block dark-bg">
        <ClassesSection />
      </section>

      {/* Trainers Section */}
<section id="trainers" ref={sectionRefs.trainers} className="section-block light-bg">
  <div className="trainer-container">
    <div className="trainer-image-container">
      <img src={trainer} alt="Ankit Sharma - Trainer" className="trainer-image" />
    </div>
    <div className="trainer-info">
      <h2>Ankit Sharma</h2>
      <p className="experience">Founder, VEDYO – Health & Wellness Coach</p>
      <p className="certification">
        10+ years in Yoga, Ayurveda & Naturopathy | Yoga Alliance USA Certified
      </p>

      <p className="experience">
        Ankit integrates timeless Indian healing sciences with modern wellness. With a rich
        background in Yogic Science, Ayurveda, Naturopathy, and Sports Science, he leads
        VEDYO as a transformative wellness platform for today’s world—offering curated
        therapies, rituals, and retreats for deep personal transformation.
      </p>

      <h4>Qualifications</h4>
      <ul className="qualifications">
        <li>Diploma, Ayurveda & Panchkarma </li>
        <li>M.Sc, Yogic Science </li>
        <li>PG Diploma, Yoga & Naturopathy </li>
        <li>QCI Level 2 Yoga Teacher </li>
        <li>B.Sc, Sports Science </li>
        <li>Foundation Course in Yoga </li>
      </ul>
    </div>
  </div>
</section>


      {/* Inquiry Section with Updated Form */}
      <section id="inquiry" ref={sectionRefs.inquiry} className="section-block dark-bg">
        <ContactFormWindow />
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919717303190"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={28} />
        <span>Chat with Us</span>
      </a>
    </section>
  );
}

export default Home;
